import {gql} from '@apollo/client';

import {UserContextFragment} from 'web-app/react/hooks/util/queries';

export const AuthChallengeFragment = gql`
    fragment AuthChallenge on AuthenticationChallenged {
        loginId
        deviceId
        expiresAt
        choices {
            context {
                ...UserContextFragment
            }
            hmac
            requiresTwoFactor
        }
        person {
            name {
                fullName
            }
            profileImage {
                url
            }
        }
    }

    ${UserContextFragment}
`;

const AuthenticationResult = gql`
    fragment AuthenticationResult on AuthenticationResult {
        status
        __typename
        ... on AuthenticationFailed {
            status
            errorDetails
            errorTitle
        }
        ... on AuthenticationSucceeded {
            accessToken
            deviceId
        }
        ... on AuthenticationChallenged {
            ...AuthChallenge
        }
    }
    ${AuthChallengeFragment}
`;

export const Authenticate = gql`
    mutation Authenticate($email: EmailAddress!, $password: Password!, $deviceId: DeviceId, $legacy: Boolean) {
        me {
            authenticateWithPassword(email: $email, password: $password, deviceId: $deviceId, legacy: $legacy) {
                ...AuthenticationResult
            }
        }
    }
    ${AuthenticationResult}
`;

export const AuthenticateWithPin = gql`
    mutation AuthenticateWithPin($loginId: LoginId!, $pin: String!, $deviceId: DeviceId!) {
        me {
            authenticateWithPin(loginId: $loginId, pin: $pin, deviceId: $deviceId) {
                ...AuthenticationResult
            }
        }
    }
    ${AuthenticationResult}
`;

export const RequestConnectTokenEmail = gql`
    mutation RequestConnectTokenEmail($email: String!) {
        me {
            requestOpenIdConnectToken(email: $email)
        }
    }
`;
